import { NavLink } from 'react-router-dom';
import s from './timezone-button.module.scss'
import useMedia from 'use-media';
import { IconEdit } from '@tabler/icons-react/dist/cjs/tabler-icons-react';
import { findGroupNameByEng } from '@entities/profile/lib/timezone-picker/utils';
import { useTimezoneModal } from '../../model/use-timezone-modal';
import { useProfile } from '@shared/api/useProfile';

export const TimezoneButton = () => {
	const {data: profile} = useProfile()
	const { open } = useTimezoneModal()
	const isTablet = useMedia({maxWidth: '1312px'})

	return (
		<div className={s.wrapper}>
			<span className={s.timezone}>{findGroupNameByEng(profile?.timezone) || profile?.timezone || 'Часовой пояс не выбран'}</span>
			<NavLink onClick={() => open()} className={s.edit}>
				{isTablet ? <IconEdit/> : 'Изменить'}
			</NavLink>
		</div>
	)
}
